import type { Gender } from "../auth/types";
import { bronzeCategories } from "../user/quiz/types";

export enum SessionGateway {
  declarative_identity = "declarative_info",
  kyc_identity = "kyc_identity",
  cryptocurrency_identity = "cryptocurrency_identity"
}

export enum SessionExternalScope {
  email = "email",
  documents = "documents"
}

export enum Currency {
  kypay = "kypay",
  euros = "euros"
}

export type Substep =
  | "phone"
  | "person"
  | "birth"
  | "nationality"
  | "nif"
  | "residence"
  | "activity"
  | "monthly_income"
  | "source_income"
  | "complete";
export type SubstepMissingField =
  | "phone.phone"
  | "identity.person"
  | "identity.birth"
  | "identity.nationality"
  | "identity.nif"
  | "identity.residence"
  | "identity.activity"
  | "identity.monthly_income"
  | "identity.source_income"
  | "complete";
const isSubstep = (value: unknown): value is Substep => {
  const casted = value as Substep;
  return casted !== undefined;
};

export const asSubstep = (value: unknown): Substep | null => {
  return isSubstep(value) ? (value as Substep) : null;
};

export const SUBSTEPS_IN_ORDER: Substep[] = [
  "person",
  "birth",
  "nationality",
  "residence",
  "nif",
  "activity",
  "monthly_income",
  "source_income"
];

export const SUBSTEPS_IN_ORDER_WITH_COMPLETE: Substep[] = [...SUBSTEPS_IN_ORDER, "complete"];

export type GetSessionByIDResponse = {
  id: string;
  scope: SessionExternalScope[];
  gateways: SessionGateway[];
  order: Order;
};
export type levelBronzeFormDataType = {
  address_justification: string | null;
  curriculum_algoreg_session_uuid: string | null;
  linkedin_url: string | null;
  career_path: string | null;
  civilState: string | null;
  assets_category: string[];
  other_assets_category: string[];
  other_assets_category_comment: string | null | undefined;
  other_assets_period: string | null | undefined;
  other_assets_annual_amount: string | null | undefined;
  monthly_income?: {
    minimum: number | null;
    maximum: number | null;
  };
  real_estate_assets: string | null;
  value_real_estate: string | null;
  debt: string | null;
  other_real_estate_assets: string[];
  other_real_estate_assets_comment?: string | null;
  other_real_estate_assets_estimation: {
    minimum: number | null;
    maximum: number | null;
  };
  origin_assets_category: string[];
  origin_assets_comment: string | null;
  comment_assets: string | null;
  honor_declaration: boolean;
};
export type levelBronzeFormDataTypeResponse = {
  address_justification: string | null;
  curriculum_algoreg_session_uuid: string | null;
  linkedin_url: string | null;
  career_path: string | null;
  civilState: string | null;
  assets_category: bronzeCategories[];
  other_assets_category: bronzeCategories[];
  other_assets_category_comment: string | null | undefined;
  other_assets_period: string | null | undefined;
  other_assets_annual_amount: string | null | undefined;
  monthly_income?: {
    minimum: number | null;
    maximum: number | null;
  };
  real_estate_assets: string | null;
  value_real_estate: string | null;
  debt: string | null;
  other_real_estate_assets: bronzeCategories[];
  other_real_estate_assets_comment?: string | null;
  other_real_estate_assets_estimation: {
    minimum: number | null;
    maximum: number | null;
  };
  origin_assets_category: bronzeCategories[];
  origin_assets_comment: string | null;
  comment_assets: string | null;
  honor_declaration: boolean;
};

export type levelBronzeFormDataResponseType = {
  data: levelBronzeFormDataType;
  success: boolean;
};

export type levelSilverFormDataType = {
  salary_saving_docs: boolean;
  investment_sales: boolean;
  property_sales: boolean;
  loan: boolean;
  address_justification: boolean;
  heritage: boolean;
  dividends_or_company_profits: boolean;
  divorce: boolean;
  gambling_winning: boolean;
  donation: boolean;
  life_insurance_policy_maturity: boolean;
};

export type Order = {
  id: string;
  amount: number;
  currency: Currency;
};

export type DeclarativeIdentity = {
  welcome?: boolean;
  person?: DeclarativePerson;
  addressBirth?: DeclarativeBirth;
  addressResidence?: DeclarativeResidence;
  occupation?: DeclarativeOccupation;
  monthlyIncome?: DeclarativeMonthlyIncome;
  taxAdress?: DeclarativeNif[];
  sourcesIncome?: DeclarativeIncomeSource[];
};

export type DeclarativePerson = {
  gender?: Gender | null;
  firstnames?: string | null;
  lastnames?: string | null;
  commonFirstName?: string | null;
  commonName?: string | null;
  otherfirstnames?: string | null;
  nationalityCodes: string[];
};
export type DeclarativeNif = {
  UUID?: string;
  country: string | null;
  tinExist: boolean | null;
  tin: string | null;
  tinCheck: boolean | null;
  apiCheck: boolean | null;
  allowUpdate?: boolean | null;
  AllowContinueQuiz?: boolean | null;
};

export type DeclarativeNifWithCountryUuid = DeclarativeNif & {
  countryUuid: string | null;
};

export type DeclarativeNifCompany = {
  UUID?: string;
  country_id: string | null;
  tinExist: boolean | null;
  tin: string | null;
  tinCheck: boolean | null;
  apiCheck: boolean | null;
  allowUpdate?: boolean | null;
  AllowContinueQuiz?: boolean | null;
};
export type DeclarativeBirth = {
  birth?: Date | null;
  cityOfBirth?: string | null;
  zip?: string | null;
  countryCode?: string | null;
};

export type DeclarativeResidence = {
  UUID?: string | null;
  addressLine?: string | null;
  zip?: string | null;
  city?: string | null;
  countryCode?: string | null;
};

export type DeclarativeOccupation = {
  activity?: string | null;
  CSPcode?: number | null;
  description: string | null;
};

export enum GatewayVote {
  Inactive = "Inactive",
  Pending = "Pending",
  Continue = "Continue",
  Block = "Block"
}

export enum FromURL {
  OlkyPayNP,
  OlkyPayLE,
  Wallet,
  Partner,
  Comave,
  None
}
export type DeclarativeMonthlyIncome = {
  trans_key: string;
  minimum: number | null;
  maximum: number | null;
};

export type DeclarativeIncomeSource = {
  source_income_id: number;
  comment?: string;
};

export enum SignupType {
  business = "business",
  individual = "individual"
}
export type MirrorConfirmMutationProps = {
  email: string;
  mirror_uuid: string;
};
